import styles from "styles/side-main-menu.module.css";
import MAIN_NAV_BAR_ITEMS from "utils/constants/MainNavBarItems.js";
import PathUtils from "utils/PathUtils.js";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import withRouter from "components/utils/withRouter.js";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function MainNavBar(props) {
  const [activeItem, setActiveItem] = useState();
  const [activeSubItem, setActiveSubItem] = useState();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const location = useLocation();

  useEffect(() => {
    let path = location.pathname;
    setActiveItem(PathUtils.getMainNavBarItemRouteName(path));
    setActiveSubItem(PathUtils.getMainNavBarSubItemName(path));
  }, [location.pathname]);

  return (
    <div 
      id={styles["side-nav-bar"]}
      className={isCollapsed ? styles["collapsed"] : ""}
    >
      <header className={styles["header-container"]}>
        {!isCollapsed && (
          <img
            id={styles["logo"]}
            src="assets/logo-color.webp"
            alt="Neuroelpis Logo"
          />
        )}
        <IconButton
          className={styles["collapse-button"]}
          onClick={() => setIsCollapsed(!isCollapsed)}
          size="small"
          sx={{
            marginLeft: isCollapsed ? "auto" : "0",
            marginRight: isCollapsed ? "auto" : "0",
          }}
        >
          {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </header>
      <div className={styles["nav-items"]}>
        {MAIN_NAV_BAR_ITEMS.map((navItem, i) => {
          const navItemContent = (
            <div
              className={
                styles["nav-item"] +
                " " +
                styles[getItemStyleClassName(navItem["routeName"])]
              }
              onClick={() => navigateView(navItem)}
            >
              <div className="d-flex justify-content-between align-items-center flex-row no-wrap">
                <div className={styles["nav-item-content"]}>
                  <img
                    src={
                      isNavBarItemActive(navItem["routeName"])
                        ? navItem["iconActive"]
                        : navItem["icon"]
                    }
                    alt={navItem["iconAltText"]}
                  />
                  {!isCollapsed && <span>{navItem["name"]}</span>}
                </div>
                {!isCollapsed && getMenuItemDownArrow(
                  navItem["children"].length,
                  isNavBarItemActive(navItem["routeName"])
                )}
              </div>
              {!isCollapsed && isNavBarItemActive(navItem["routeName"])
                ? getNavBarItemChildren(navItem["children"])
                : null}
            </div>
          );

          return isCollapsed ? (
            <Tooltip key={i} title={navItem["name"]} placement="right" arrow>
              {navItemContent}
            </Tooltip>
          ) : (
            <div key={i}>{navItemContent}</div>
          );
        })}
      </div>
      {!isCollapsed && (
        <button
          type="button"
          className={styles["help-button"]}
          onClick={() =>
            window.open(
              "https://acsestech.atlassian.net/servicedesk/customer/portal/1",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Get Help
        </button>
      )}
    </div>
  );

  function navigateView(navItem) {
    setActiveItem(navItem["routeName"]);
    if (navItem["children"].length === 0) {
      // change view
      props.navigate(navItem["navigateTo"] || navItem["routeName"]);
    } else if (isCollapsed) {
      // If collapsed and has children, expand to show children
      setIsCollapsed(false);
    }
  }

  function getNavBarItemChildren(childrenItems) {
    if (childrenItems.length === 0) return null;
    return (
      <div className="mt-2">
        {childrenItems.map((childItem, i) => (
          <div
            key={i}
            className={
              styles["nav-sub-item"] +
              " " +
              styles[getSubItemStyleClassName(childItem["name"])]
            }
            onClick={() => navigateSubView(childItem)}
          >
            <span>{childItem["name"]}</span>
          </div>
        ))}
      </div>
    );
  }

  function getMenuItemDownArrow(childrenLength, isActive) {
    if (childrenLength === 0) return null;
    if (isActive)
      return (
        <img
          className={styles["down-arrow-icon"]}
          src="assets/down-arrow-icon.svg"
          alt="Down Arrow Icon"
        />
      );
    else
      return (
        <img
          className={styles["down-arrow-icon"]}
          src="assets/down-arrow-icon.svg"
          alt="Down Arrow Icon"
        />
      );
  }

  function navigateSubView(navSubItem) {
    setActiveSubItem(navSubItem["name"]);
    props.navigate(navSubItem["routeName"]);
  }

  function isNavBarItemActive(navItemName) {
    return navItemName === activeItem;
  }

  function getItemStyleClassName(navItemName) {
    if (navItemName === activeItem) return "active-nav-item";
    return "";
  }

  function getSubItemStyleClassName(navSubItemName) {
    if (navSubItemName === activeSubItem) return "active-nav-sub-item";
    return "";
  }
}

export default withRouter(MainNavBar);
